// Review W7: a form that edits a versioned record keeps the version and the record its draft started from. The save is
// checked against that version, so someone else's save in between is refused (409) rather than overwritten; "changed"
// is measured from that record, so a refetch alone never makes an untouched form look edited.

/** Whether two flat drafts read the same. */
export function isSameDraft<T extends object>(a: T, b: T): boolean {
  return JSON.stringify(a) === JSON.stringify(b);
}

/**
 * The draft moved onto a newer record: each field the person changed from `was` keeps their value; every other field
 * takes `now`'s. Shallow: every draft that uses it is one level of plain values.
 */
export function rebasedDraft<T extends object>(mine: T, was: T, now: T): T {
  const next = { ...now };
  for (const key of Object.keys(now) as (keyof T)[]) {
    if (JSON.stringify(mine[key]) !== JSON.stringify(was[key])) next[key] = mine[key];
  }
  return next;
}
